import { render, staticRenderFns } from "./Technician.vue?vue&type=template&id=48cdffca&"
import script from "./Technician.vue?vue&type=script&lang=js&"
export * from "./Technician.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports